import React from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  FormControl,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { CARD_HELP_TEXT, CardHeadingWithHelp } from "../shared/help";

const FnfSection = ({
  canManagePayroll,
  canFinance,
  fnfForm,
  setFnfForm,
  employees,
  handleCreateFnf,
  fnfRecords,
  fnfEdits,
  setFnfEdits,
  handleUpdateFnf,
  meta,
  formatPayrollCurrency,
}) => (
  <Stack spacing={6}>
    {canManagePayroll || canFinance ? (
      <Card>
        <CardHeader>
          <CardHeadingWithHelp
            title="Create Full & Final Record"
            helpText={CARD_HELP_TEXT.createFnf}
          />
        </CardHeader>
        <CardBody>
          <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing={4}>
            <FormControl>
              <FormLabel>Employee</FormLabel>
              <Select
                value={fnfForm.userId}
                onChange={(e) =>
                  setFnfForm((prev) => ({ ...prev, userId: e.target.value }))
                }
              >
                <option value="">Select employee</option>
                {employees.map((employee) => (
                  <option key={employee._id} value={employee._id}>
                    {employee.name}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel>Relieving Date</FormLabel>
              <Input
                type="date"
                value={fnfForm.relievingDate}
                onChange={(e) =>
                  setFnfForm((prev) => ({
                    ...prev,
                    relievingDate: e.target.value,
                  }))
                }
              />
            </FormControl>
            <FormControl>
              <FormLabel>Status</FormLabel>
              <Select
                value={fnfForm.status}
                onChange={(e) =>
                  setFnfForm((prev) => ({ ...prev, status: e.target.value }))
                }
              >
                <option value="DRAFT">DRAFT</option>
                <option value="SETTLED">SETTLED</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel>Unpaid Salary (Rupees)</FormLabel>
              <Input
                type="number"
                value={fnfForm.unpaidSalary}
                onChange={(e) =>
                  setFnfForm((prev) => ({
                    ...prev,
                    unpaidSalary: e.target.value,
                  }))
                }
              />
            </FormControl>
            <FormControl>
              <FormLabel>Leave Encashment (Rupees)</FormLabel>
              <Input
                type="number"
                value={fnfForm.leaveEncashment}
                onChange={(e) =>
                  setFnfForm((prev) => ({
                    ...prev,
                    leaveEncashment: e.target.value,
                  }))
                }
              />
            </FormControl>
            <FormControl>
              <FormLabel>Gratuity (Rupees)</FormLabel>
              <Input
                type="number"
                value={fnfForm.gratuity}
                onChange={(e) =>
                  setFnfForm((prev) => ({ ...prev, gratuity: e.target.value }))
                }
              />
            </FormControl>
            <FormControl>
              <FormLabel>Deductions (Rupees)</FormLabel>
              <Input
                type="number"
                value={fnfForm.deductions}
                onChange={(e) =>
                  setFnfForm((prev) => ({
                    ...prev,
                    deductions: e.target.value,
                  }))
                }
              />
            </FormControl>
            <FormControl gridColumn={{ xl: "2 / span 2" }}>
              <FormLabel>Note</FormLabel>
              <Input
                value={fnfForm.note}
                onChange={(e) =>
                  setFnfForm((prev) => ({ ...prev, note: e.target.value }))
                }
              />
            </FormControl>
          </SimpleGrid>
          <Button mt={4} colorScheme="blue" onClick={handleCreateFnf}>
            Save F&F
          </Button>
        </CardBody>
      </Card>
    ) : null}

    <Card>
      <CardHeader>
        <CardHeadingWithHelp
          title="F&F Records"
          helpText={CARD_HELP_TEXT.fnfRecords}
        />
      </CardHeader>
      <CardBody>
        <TableContainer>
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Employee</Th>
                <Th>Relieving</Th>
                <Th>Net Settlement</Th>
                <Th>Status</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {fnfRecords.map((record) => {
                const draft = fnfEdits[record._id] || {};
                return (
                  <Tr key={record._id}>
                    <Td>{record.userId?.name || "-"}</Td>
                    <Td>
                      {new Date(record.relievingDate).toLocaleDateString()}
                    </Td>
                    <Td>{formatPayrollCurrency(record.netSettlement, meta)}</Td>
                    <Td>
                      {(canManagePayroll || canFinance) &&
                      record.status !== "SETTLED" ? (
                        <Select
                          size="xs"
                          value={draft.status || record.status}
                          onChange={(e) =>
                            setFnfEdits((prev) => ({
                              ...prev,
                              [record._id]: {
                                ...prev[record._id],
                                status: e.target.value,
                              },
                            }))
                          }
                        >
                          <option value="DRAFT">DRAFT</option>
                          <option value="SETTLED">SETTLED</option>
                        </Select>
                      ) : (
                        <Badge
                          colorScheme={
                            record.status === "SETTLED" ? "green" : "orange"
                          }
                        >
                          {record.status}
                        </Badge>
                      )}
                    </Td>
                    <Td>
                      {(canManagePayroll || canFinance) &&
                      record.status !== "SETTLED" ? (
                        <Button
                          size="xs"
                          onClick={() => handleUpdateFnf(record._id)}
                        >
                          Save
                        </Button>
                      ) : null}
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableContainer>
      </CardBody>
    </Card>
  </Stack>
);

export default FnfSection;
